import { api } from './apiClient.js';

/** POST /v1/workspace/vault/list */
export const listVaults = (body) => api.post('/v1/workspace/vault/list', body);

/** POST /v1/workspace/vault/:vaultUuid/agent/unassign */
export const unassignAgentFromVault = (vaultUuid, agentUuid) =>
  api.post(`/v1/workspace/vault/${encodeURIComponent(vaultUuid)}/agent/unassign`, {
    agent_uuid: agentUuid,
  });

/**
 * POST /v1/workspace/vault/:vaultUuid/agent
 * @param {string} vaultUuid
 * @param {string} agentUuid
 * @param {string} [privilege='READER']
 * @param {string} [description='']
 */
export const assignAgentToVault = (
  vaultUuid,
  agentUuid,
  privilege = 'READER',
  description = '',
) =>
  api.post(`/v1/workspace/vault/${encodeURIComponent(vaultUuid)}/agent`, {
    agent_uuid: agentUuid,
    privilege,
    description,
  });
